/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * FilterPhotoIcon
 */
export default class FilterPhotoIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M15 2a1 1 0 01.117 1.993L15 4H6.6a2.6 2.6 0 00-2.595 2.436L4 6.6v10.8a2.6 2.6 0 002.436 2.595L6.6 20h10.8a2.6 2.6 0 002.595-2.436L20 17.4V9a1 1 0 011.993-.117L22 9v8.4a4.6 4.6 0 01-4.39 4.595L17.4 22H6.6a4.6 4.6 0 01-4.595-4.39L2 17.4V6.6a4.6 4.6 0 014.39-4.595L6.6 2H15zm-2.798 5.166c.267.072.476.281.548.548l.45 1.674a2 2 0 001.412 1.411l1.674.451a.777.777 0 010 1.5l-1.674.45a2 2 0 00-1.411 1.412l-.451 1.674a.777.777 0 01-1.5 0l-.45-1.674A2 2 0 009.387 13.2l-1.674-.451a.777.777 0 010-1.5l1.674-.45A2 2 0 0010.8 9.387l.451-1.674a.777.777 0 01.952-.548zm6.92-5.066c.16.043.285.168.328.329l.15.56a2 2 0 001.412 1.41l.56.151a.466.466 0 010 .9l-.56.15A2 2 0 0019.6 7.013l-.151.56a.466.466 0 01-.9 0l-.15-.56A2 2 0 0016.987 5.6l-.56-.151a.466.466 0 010-.9l.56-.15A2 2 0 0018.4 2.987l.151-.56a.466.466 0 01.571-.328z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

